/**
 * Standard API user-facing text from RightTimeApi responses.
 * Reads backend `jsonData.message` (and nested `reason.data.message`).
 * Also accepts legacy `error` / `errorMessage` — never `msg`.
 */
export function apiMessage(
  respOrJson:
    | { jsonData?: unknown; reason?: { data?: unknown } }
    | Record<string, unknown>
    | null
    | undefined,
  fallback = ""
): string {
  const fromBody = (data: unknown): string => {
    if (!data || typeof data !== "object") return "";
    const body = data as Record<string, unknown>;
    for (const key of ["message", "error", "errorMessage"] as const) {
      const value = body[key];
      if (typeof value === "string" && value.trim()) return value;
    }
    return "";
  };

  if (!respOrJson || typeof respOrJson !== "object") return fallback;

  const resp = respOrJson as {
    jsonData?: unknown;
    reason?: { data?: unknown };
  };

  if ("jsonData" in respOrJson || "reason" in respOrJson) {
    return (
      fromBody(resp.jsonData) ||
      fromBody(resp.reason?.data) ||
      fallback
    );
  }

  return fromBody(respOrJson) || fallback;
}
